import { fmtDateTimeIST } from '@/lib/format';

export const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export function isDirty(local, remote) {
  if (!local || !remote) return false;
  // Quick string compare on the relevant subset of fields.
  const pick = (t) => ({
    name: t.name ?? '',
    brand_color: t.brand_color ?? '',
    show_photo: !!t.show_photo,
    show_contact_details: !!t.show_contact_details,
    footer_note: t.footer_note ?? '',
    sections: (t.sections ?? []).map((s) => ({
      key: s.key, label: s.label, order: Number(s.order || 0),
      enabled: !!s.enabled, ai_hint: s.ai_hint ?? '',
    })),
  });
  try {
    return JSON.stringify(pick(local)) !== JSON.stringify(pick(remote));
  } catch {
    return true;
  }
}

export function formatTimestamp(iso) {
  if (!iso) return '—';
  try {
    return fmtDateTimeIST(iso, {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit',
    }, String(iso));
  } catch { return String(iso); }
}
